module.exports = __webpack_public_path__ + "img/ficha.a49045e2.png";